import { TooltipQuestionOutlineIcon } from './TooltipQuestionOutlineIcon';

/**
 * author: Jeff Anders
 * id CD2A99C9-F223-42EB-BD90-5786EACF9A52
 * name tooltip-question-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-question-outline.svg
 * tags
 * - Tooltip 
 */
export const TooltipHelpOutlineIcon = TooltipQuestionOutlineIcon;
export default TooltipHelpOutlineIcon